export {default} from 'views/AccountStatementReport/AccountStatementReport'


// WEBPACK FOOTER //
// ./src/views/Reports/AccountStatementReport.jsx